import { api } from './_apiInterface';
import { pointer } from 'src/app-config';
import { typeNotificationsDoc } from '@monorepo/models';

class NotificationServices {
    private _base = pointer.notification;
    //
    Get = async () => {
        const data = await api.SendRequest<{ notificationsDoc: typeNotificationsDoc; }>(this._base, 'GET');
        return data;
    }
    SetNotificationsOfTheDayAgain = async () => {
        const data = await api.SendRequest(this._base, 'POST');
        return data;
    }
    SetOptions = async (notificationsDoc: typeNotificationsDoc) => {
        const data = await api.SendRequest(this._base, 'PUT', { notificationsDoc });
        return data;
    }
}

export const notificationServices = new NotificationServices();
